<template>
  <!--
      作者 luoyiming
      时间：2020-06-09
      描述：会员-积分管理
  -->
  <div class="common-seach-wrap">
    <el-tabs v-model="activeName">
      <el-tab-pane label="余额明细" name="log"></el-tab-pane>
    </el-tabs>
    <!--余额明细-->
    <Log v-if="activeName == 'log'"></Log>
  </div>
</template>
<script>
import Log from './part/Log';
export default {
  components: {
    Log
  },
  data() {
    return {
      form: {
        status: 0
      },
      activeName: 'log'
    };
  },
  methods: {}
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/user/balance/index.vue